import { Action } from "redux";
import {
    PatientIndividualInformationDto,
    EmailCheckin,
    PhoneCheckin,
    AddressCheckin,
    DemographicsCheckin,
    HealthCardCheckin,
    PreferredPharmacyCheckin,
} from "../../dtos/KioskDtos.dtos";
import {
    SELECT_PATIENT_INFO_MODE,
    STAGE_PATIENT_DATA,
    SAVE_PATIENT_EMAILS,
    TOGGLE_PATIENT_INFO_EDIT_POPUP,
    SAVE_PATIENT_PHONES,
    SAVE_PATIENT_ADDRESSES as SAVE_PATIENT_ADDRESSES,
    SAVE_PATIENT_DEMOGRAPHICS,
    SAVE_PATIENT_PREFERRED_PHARMACY,
    PATIENT_CREATION_SUCCESSFUL,
} from "./constants";

export enum PATIENT_INFO_MODE { NOT_CHOSEN, CREATE, UPDATING }
export enum PATIENT_OVERVIEW_EDIT_WINDOW { NONE, DEMOGRAPHICS, ADDRESS, EMAIL, PHONE, PREFERRED_PHARMACY }

export type DEMOGRAPHICS = 'demographics';
export type HEALTHCARD = 'healthcard';
export type ADDRESSES = 'addresses';
export type EMAILS = 'emails';
export type PHONES = 'phones';
export type PREFERRED_PHARMACY = 'preferredPharmacy';

export type PATIENT_INFO_CONTACT_TYPES = ADDRESSES | EMAILS | PHONES;
export type PATIENT_INFO_KEYS = DEMOGRAPHICS | PATIENT_INFO_CONTACT_TYPES | HEALTHCARD | PREFERRED_PHARMACY;

export interface IPatientInfoContactTypes {
    ADDRESSES: ADDRESSES;
    EMAILS: EMAILS;
    PHONES: PHONES;
}

export interface IPatientInfoKeys extends IPatientInfoContactTypes {
    DEMOGRAPHICS: DEMOGRAPHICS;
    HEALTHCARD: HEALTHCARD;
    PREFERRED_PHARMACY: PREFERRED_PHARMACY;
}

export const PATIENT_INFO_CONTACT_TYPES: IPatientInfoContactTypes = { ADDRESSES: "addresses", EMAILS: "emails", PHONES: "phones" }
export const PATIENT_INFO_KEYS: IPatientInfoKeys = {
    ...PATIENT_INFO_CONTACT_TYPES,
    DEMOGRAPHICS: "demographics",
    HEALTHCARD: "healthcard",
    PREFERRED_PHARMACY: "preferredPharmacy"
};

export type PATIENT_INFO_FORM_TYPE = ADDRESSES | EMAILS | PHONES;

/**
 * @export
 * @interface PatientInformationFormState
 * @description Declare Interface for our Patient Information Form state feature.
 */
export interface PatientInformationFormState {
    patientInformation: PatientIndividualInformationDto,
    patientInfoChanged: boolean,
    patientInterfaceForm: {
        patientCreated: boolean,
        showDateSelector: boolean,
        currentPatientInfoMode: PATIENT_INFO_MODE,
        phoneOption1ExtVisible: boolean,
        phoneOption2ExtVisible: boolean,
        phoneEditStatus: boolean,
        emailEditStatus: boolean,
        addressTabIndex: number,
        patientInfoEditIsNewItem: boolean,
        patientInfoEditPopupVisible: boolean,
        patientInfoEditIndex: number,
        patientInfoEditSelectedCategory: PATIENT_OVERVIEW_EDIT_WINDOW,
        patientInfoEditDeletePopupVisible: boolean,
        patientInfoDeletePopupCategory: PATIENT_OVERVIEW_EDIT_WINDOW.NONE,
    }
}

export interface PatientInfoSendingMode extends Action {
    type: SELECT_PATIENT_INFO_MODE,
    payload: {
        status: PATIENT_INFO_MODE
    }
}
export interface PatientCreationSuccessfulAction extends Action {
    type: PATIENT_CREATION_SUCCESSFUL,
    payload: {
        status: boolean
    }
}

export interface StagePatientDataInfoAction extends Action {
    type: STAGE_PATIENT_DATA;
    payload: {
        patientInfo: PatientIndividualInformationDto
    };
}

//// PATIENT OVERVIEW////
export interface TogglePatientInformationEditPopupAction extends Action {
    type: TOGGLE_PATIENT_INFO_EDIT_POPUP,
    payload: {
        show: boolean,
        type?: PATIENT_OVERVIEW_EDIT_WINDOW,
        index?: number,
        isNewItem?: boolean
    }
}

export interface SaveEmailEditAction extends Action {
    type: SAVE_PATIENT_EMAILS,
    payload: {
        emails: EmailCheckin[]
    }
}

export interface SavePhoneEditAction extends Action {
    type: SAVE_PATIENT_PHONES,
    payload: {
        phones: PhoneCheckin[]
    }
}

export interface SaveAddressEditAction extends Action {
    type: SAVE_PATIENT_ADDRESSES,
    payload: {
        addresses: AddressCheckin[]
    }
}

export interface SaveDemographicsEditAction extends Action {
    type: SAVE_PATIENT_DEMOGRAPHICS,
    payload: {
        demographics: DemographicsCheckin,
        healthCard: HealthCardCheckin
    }
}

export interface SavePreferredPharmacyEditAction extends Action {
    type: SAVE_PATIENT_PREFERRED_PHARMACY,
    payload: {
        preferredPharmacy: PreferredPharmacyCheckin
    }
}

export type PatientInformationFormActions =
    PatientCreationSuccessfulAction |
    PatientInfoSendingMode |
    StagePatientDataInfoAction |
    TogglePatientInformationEditPopupAction |
    SaveEmailEditAction |
    SavePhoneEditAction |
    SaveDemographicsEditAction |
    SaveAddressEditAction |
    SavePreferredPharmacyEditAction;


// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/type.ts